<template>
  <div class="authorCenter">
    <authorHeader></authorHeader>
    <div class="breadbox">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <div class="clearfix bread">
          <img src="~img/direction.png" alt="" />
          <el-breadcrumb-item
            v-for="item in breadlist"
            :key="item.path"
            :to="{ path: item.path }"
            >{{ item.name }}</el-breadcrumb-item
          >
        </div>
      </el-breadcrumb>
    </div>
    <div class="contianer clearfix">
      <authorbar
        :navlist="navlist"
        :isSmall="true"
        :oIndex="oIndex"
        :bookdetail="bookdetail"
        :sAuthor="true"
        @isShowhint="isShowhint"
        @openApply="openApply"
      ></authorbar>
      <div class="con-right fr">
        <template>
          <div class="chapterNav clearfix">
            <div class="nav-left fl">
              <router-link :to="'/authorManage/bookSetting/' + bookid"
                >作品设置 <span></span
              ></router-link>
              <router-link :to="'/authorManage/newChapter/' + bookid"
                >新建章节 <span></span
              ></router-link>
              <router-link :to="'/authorManage/published/' + bookid"
                >已发布章节 <span></span
              ></router-link>
              <router-link :to="'/authorManage/drafts/' + bookid"
                >草稿箱 <span></span
              ></router-link>
              <router-link :to="'/authorManage/sign/' + bookid"
                >申请签约 <span></span
              ></router-link>
            </div>
            <router-link to="/author" class="fr newChapter"
              >返回全部作品</router-link
            >
          </div>
        </template>
        <router-view></router-view>
      </div>
    </div>
    <pop
      :isShowPop="isShowPop"
      :isShowEnd="isShowEnd"
      :isShowOpen="isShowOpen"
      :finishStatus="finishStatus"
      :openStatus="openStatus"
      @changeobj="changeobj"
      @openBook="openBook"
      @canclefinish="canclefinish"
      @finishbook="finishbook"
    ></pop>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getAbookid } from "utils/storage";
import { finishbook, getfinishbook, publishBook } from "apiurl/author";
import { bookInfo, getOpenStatus } from "apiurl/book";
export default {
  data() {
    return {
      breadlist: [], // 面包屑租
      pagepath: "",
      oIndex: null,
      navlist: [],
      isShowEnd: false, //申请完结
      isShowPop: false,
      isShowOpen: false,
      finishStatus: { code: 0, desc: "草稿" },
      openStatus: { code: 0, desc: "未申请" },
      bookdetail: {}
    };
  },
  created() {
    this.getBreadcrumb();
    this.pagepath = this.$route.path;
    this.$nextTick(() => {
      this.agetfinishbook();
      this.getOpenInfo();
      this.getBookInfo();
    });
  },
  watch: {
    $route: {
      handler() {
        /* 面包屑 */
        this.getBreadcrumb();
      },
      immediate: true
    },
    // 作品id改变，信息也随之变化
    bookid(old, news) {
      this.getBookInfo(news);
    }
  },
  computed: mapState({
    bookid: state => state.author.bookid
  }),
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name);
      this.breadlist = matched;
    },
    // 弹出申请完结弹框
    isShowhint(value) {
      this.isShowEnd = value;
      this.isShowPop = value;
    },
    canclefinish() {
      this.isShowEnd = false;
      this.isShowPop = false;
    },
    changeobj() {
      this.isShowEnd = false;
      this.isShowOpen = false;
      this.isShowPop = false;
    },
    // 申请完本
    finishbook() {
      if (this.finishStatus.code == 0 || finishStatus.code == -2) {
        finishbook(this.bookid)
          .then(res => {
            if (res.success) {
              this.$message({
                message: "申请成功",
                type: "success"
              });
              this.agetfinishbook();
            }
          })
          .catch(() => {});
      }
      this.isShowEnd = false;
      this.isShowPop = false;
    },
    // 申请公开
    openApply() {
      this.isShowOpen = true;
      this.isShowPop = true;
    },
    openBook() {
      if (this.openStatus.code == 0 || this.openStatus.code == -2) {
        publishBook(this.bookid)
          .then(res => {
            if (res.success) {
              this.$message({
                message: "公开申请已提交",
                type: "success"
              });
            }
            this.isShowOpen = false;
            this.isShowPop = false;
            this.getOpenInfo();
          })
          .catch(() => {});
      }
      this.isShowOpen = false;
      this.isShowPop = false;
    },
    // 获取申请完本状态
    agetfinishbook() {
      if (getAbookid() !== "undefined" && getAbookid() !== "0") {
        getfinishbook(this.bookid).then(res => {
          if (res.success) {
            if (res.data.code) {
              this.finishStatus = res.data;
            }
          }
        });
      }
    },
    // 获取公开信息
    getOpenInfo() {
      if (getAbookid() !== "undefined" && getAbookid() !== "0") {
        getOpenStatus(this.bookid).then(res => {
          if (res.success) {
            if (res.data.code) {
              this.openStatus = res.data;
            }
          }
        });
      }
    },
    getBookInfo() {
      bookInfo({ bookId: this.bookid }).then(res => {
        if (res.success) {
          this.bookdetail = res.data;
        }
      });
    }
  },
  mounted() {
    // this.bookid = getAbookid();
    this.navlist = [
      { url: "/authorManage/bookSetting/" + this.bookid, name: "作品管理" },
      { url: "", name: "申请公开" },
      { url: "", name: "设置完本" }
    ];
  }
};
</script>

<style lang="stylus" scoped>
.el-breadcrumb
     width 1180px
.contianer
    width 1180px
    margin 0 auto 70px
    .con-left
        width 138px !important
    .con-right
        width 990px
        min-height 738px
        .chapterNav
            background rgba(238, 238, 238, 1)
            height 48px
            padding 0 16px 0 24px
            color #888
            font-size 16px
            font-weight 500
            line-height 48px
            overflow hidden
            .nav-left
                a
                    margin-right 30px
                    position relative
                    height 48px
                    display inline-block
                    color #7992A4
                    span
                        display none
                        width 18px
                        height 4px
                        background #48a2df
                        position absolute
                        bottom 1px
                        left 0px
                        right 0px
                        margin 0 auto
                    &.router-link-exact-active
                        color #48a2df
                        span
                            display inline-block
            .newChapter
                height 24px
                border-radius 4px
                text-align center
                line-height 24px
                font-size 12px
                margin-top 12px
                color #48a2df
                font-weight 400
</style>
